export const POOL_DATA = {
  UserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
  ClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
  AccessKeyId: import.meta.env.VITE_COGNITO_ACCESS_KEY_ID,
  SecretAccessKey: import.meta.env.VITE_COGNITO_SECRET_ACCESS_KEY,
};
